export const reportingHelpState = {
    name: 'app.reporting.help',
    url: '/help',
    component: 'reporting'
};
